import ComplexTable from 'components/table';
import { createColumnHelper } from '@tanstack/react-table';
import { Link, useNavigate } from 'react-router-dom';
import Button from 'components/button';
import { HiArrowRight, HiDocumentDuplicate } from 'react-icons/hi';
import UseApi from 'hooks/useApi';
import { IFilter } from 'types';
import { encodeFilters } from 'utils';

type RowObj = {
  _id: string;
  packageName: number;
  startDate: string;
  endDate: string;
  availableSeats: string;
};

const PackagesTable = () => {
  const { getApi } = UseApi();
  const navigate = useNavigate();

  const handleDuplicate = async (packageId: string) => {
    try {
      const response = await getApi(`packages/${packageId}`);
      const packageData = response.data;
      
      navigate('/admin/package/duplicate', { state: { packageData, isDuplicate: true } });
    } catch (error) {
      console.error('Error fetching package for duplication:', error);
    }
  };

  const columnHelper = createColumnHelper<RowObj>();
  const columns = [
    columnHelper.accessor('packageName', {
      id: 'packageName',
      header: () => <p className="  ">NAME</p>,
      cell: (info) => <p className="  ">{info.getValue()}</p>,
    }),

    columnHelper.accessor('startDate', {
      id: 'startdate',
      header: () => <p className="  ">START DATE</p>,
      cell: (info) => <p className="  ">{info.getValue()?.substring(0, 10)}</p>,
    }),
    columnHelper.accessor('endDate', {
      id: 'enddate',
      header: () => <p className="  ">END DATE</p>,
      cell: (info) => <p className="  ">{info.getValue()?.substring(0, 10)}</p>,
    }),

    columnHelper.accessor('availableSeats', {
      id: 'availableSeats',
      header: () => <p className="  ">AVAILABLE SEATS</p>,
      cell: (info) => <p className="  ">{info.getValue()}</p>,
    }),
    columnHelper.accessor('_id', {
      id: '_id',
      header: () => <p className="  ">ACTIONS</p>,
      cell: (info) => (
        <div className="flex gap-2">
          <Button 
            type="icon" 
            onClick={() => handleDuplicate(info.getValue())}
          >
            <HiDocumentDuplicate />
          </Button>
          <Link key={1} to={info.getValue()}>
            <Button type="icon">
              <HiArrowRight />
            </Button>
          </Link>
        </div>
      ),
    }),
  ];

  const filters: IFilter[] = [
    { key: 'name', type: 'text', label: 'Name' },
    { key: 'startDateFrom', type: 'date', label: 'From Date' },
    { key: 'endDateTo', type: 'date', label: 'To Date' },
    { key: 'availableSeats', type: 'number', label: 'Available Seats' },
    {
      key: 'showArchived',
      type: 'select',
      options: ['false', 'true'],
      label: 'Archived',
    },
  ];

  async function fetchData(
    options: any,
    filterState: { [key: string]: string },
  ) {
    const { pageIndex, pageSize } = options;
    const response = await getApi(
      `packages?page=${pageIndex + 1}&limit=${pageSize}${encodeFilters(
        filterState,
      )}`,
    );
    const data = response.data.data.packages;
    const pageCount = response.data.data.totalPages;
    return {
      rows: data,
      pageCount,
    };
  }
  return (
    <div>
      <ComplexTable columns={columns} fetchData={fetchData} filters={filters} />
    </div>
  );
};
export default PackagesTable;
